export const TRAILER_VEHICLE_TYPE = "หางลาก";

export const VEHICLE_TIRE_LIMIT = 20;

export const isTrailerType = (type?: string | null) =>
  type === TRAILER_VEHICLE_TYPE;

export const VEHICLE_TYPE_CREATABLE_FIELD_NAME = "vehicle_type";

/**
 * The 5 seeded vehicle types created by the migration. They are locked from
 * delete/rename in the FE (matches AC: "หางลาก ลบไม่ได้ เปลี่ยนชื่อไม่ได้",
 * and the same lock is applied to the other four for consistency with the
 * "master row is a system row" concept).
 */
export const SEEDED_VEHICLE_TYPES: readonly string[] = [
  "4 ล้อ",
  "6 ล้อ",
  "10 ล้อ",
  "18 ล้อ",
  TRAILER_VEHICLE_TYPE,
];
